import React from 'react';

interface ComboBoxOption {
  value: string | number;
  label: string;
  key: string | number;
}

interface ComboBoxProps {
  value: string | number;
  options: ComboBoxOption[];
  onChange: (value: string | number) => void;
  selectStyle?: React.CSSProperties;
  optionStyle?: React.CSSProperties;
  className?: string;
}

export default function ComboBox({
  value,
  options,
  onChange,
  selectStyle = {},
  optionStyle = {},
  className = "select"
}: ComboBoxProps) {
  return (
    <select
      value={value}
      className={className}
      style={selectStyle}
      onChange={(e) => onChange(e.target.value)}
    >
      {options.map((option) => (
        <option
          key={option.key}
          value={option.value}
          style={optionStyle}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
}